// @ts-check

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import RenderedSolutionContainer from './RenderedSolutionContainer'

const useStyles = makeStyles((theme) => ({
  renderedModelWrapper: {
    // flexGrow: 2,
    // maxHeight: '600px',
    margin: '5px',
    height: '120vh;',
    // minHeight: '400px',
    maxWidth: '40vw',
  }
}));

function RenderedSolutionWrapper(props) {
  // display solution name on top
  const styles = useStyles();
  return (
    <div className={styles.renderedModelWrapper}>
      {/*TODO: Disable 3d */}
      <RenderedSolutionContainer />
    </div>
  )
}

export default RenderedSolutionWrapper